import { render } from "./TransfersList.vue?vue&type=template&id=4e32e287"
import script from "./TransfersList.vue?vue&type=script&lang=js"
export * from "./TransfersList.vue?vue&type=script&lang=js"

import "./TransfersList.vue?vue&type=style&index=0&id=4e32e287&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__